import styled from 'styled-components/macro';

export const OptionsWrapper = styled.div`
    justify-content: space-between;
    position: relative;
    max-width: 100%;
    display: flex;
    width: 100%;
`;
